/**
 * Tipos da API de Lotes (M6) consumidos pela tela de lotes e custo (M10/M11).
 * Contrato: docs/api-contracts.md → Módulo M6 (`GET /lotes`, `POST /lotes`,
 * `POST /lotes/{id}/aprovacao`).
 */

/** Status de lote do contrato de `GET /lotes` (o teste lê a lista do contrato). */
export const LOTE_STATUS = ['montando', 'em_execucao', 'concluido', 'falha'] as const;
export type LoteStatus = (typeof LOTE_STATUS)[number];

/** Status em que o lote ainda anda — a tela faz polling enquanto houver algum. */
export const LOTE_STATUS_EM_ANDAMENTO: ReadonlySet<string> = new Set(['montando', 'em_execucao']);

/** Item de `GET /lotes`. `tipo` é o do banco (`piloto|carga_total|incremental|reprocessamento`). */
export interface LoteListItem {
  readonly loteId: string;
  readonly tipo: string;
  readonly status: LoteStatus;
  readonly versaoPrompt?: string;
  readonly processados: number;
  readonly emFila: number;
  readonly comFalha: number;
  readonly custoAcumuladoUsd: number;
  /** Custo médio por documento processado (ADR-033); null sem processados. Ausente em API antiga. */
  readonly custoPorDocumentoUsd?: number | null;
  readonly criadoEm?: string;
  /** ADR-036: visitas dos itens `ok` do lote ("Ver as N visitas"). Ausente em API antiga. */
  readonly visitas?: number;
  /** ADR-036: o reprocessamento que criou o lote, ou null. */
  readonly origemReprocessamentoId?: string | null;
  /** ADR-050: o consumo medido das chamadas ao modelo; null sem medição. Ausente em API antiga. */
  readonly consumo?: ConsumoLote | null;
}

/** ADR-050 (spec custo-da-leitura): o consumo medido de um lote — médias por documento medido. */
export interface ConsumoLote {
  readonly documentosMedidos: number;
  readonly tokensEntradaPorDocumento: number;
  readonly tokensSaidaPorDocumento: number;
  readonly percentualCache: number;
  readonly percentualReleitura: number;
  readonly custoMedioReleituraUsd: number | null;
}

/** Body de `POST /lotes`. */
export interface CriarLoteInput {
  readonly tipo: 'piloto' | 'total' | 'incremental';
  readonly versaoPrompt: string;
  readonly filtro?: Record<string, unknown>;
}

/** Resposta de `POST /lotes` (202). */
export interface CriarLoteResponse {
  readonly loteId: string;
  readonly status: 'montando';
  readonly versaoPrompt: string;
}

/** Resposta de `POST /lotes/{id}/aprovacao`. */
export interface AprovarLoteResponse {
  readonly loteId: string;
  readonly aprovadoEm: string;
}

/** GET /lotes/releitura — estimativa da releitura dos "outro documento" (ADR-034). */
export interface EstimativaReleitura {
  readonly documentos: number;
  /** null sem histórico de custo. */
  readonly custoEstimadoUsd: number | null;
  readonly versaoPrompt: string;
}

/** POST /lotes/releitura (202). Sem documentos, `loteId` é nulo e nenhum lote é criado. */
export interface ReleituraResponse {
  readonly loteId: string | null;
  readonly documentos: number;
  readonly versaoPrompt: string;
}
